import { default as LinkValidator } from '~/validators/Link'

const LinksValidator = (prop, name) => prop.some(link => LinkValidator(link, name))

export default LinksValidator
